import { AuditLog } from "./AuditLog";
import { EmailMetricsCard } from "./EmailMetricsCard";
import { EmailStatusCard } from "./EmailStatusCard";
import { ErrorLogs } from "./ErrorLogs";
import { OperationalCostsPanel } from "./OperationalCostsPanel";
import { PricingSettings } from "./PricingSettings";
import { RevenueCard } from "./RevenueCard";
import { StaffPanel } from "./StaffPanel";
import { TokenOverview } from "./TokenOverview";
import { TokenPricingSettings } from "./TokenPricingSettings";
import { SystemPanel } from "./system/SystemPanel";
import { PlatformNotify } from "./PlatformNotify";
import { AvatarResetPanel } from "./AvatarResetPanel";

// تبويبات: التوكنات · التكاليف التشغيلية · التسعير · الإيرادات · النظام · البريد · الفريق · التدقيق · السجلات.
export const PlatformPanelsB = ({ tab, state, sub, onSub }) => {
  if (tab === "tokens")
    return (
      <div className="grid gap-6">
        <TokenOverview />
        <TokenPricingSettings />
      </div>
    );

  if (tab === "faceCost") return <OperationalCostsPanel />;
  if (tab === "notify") return <PlatformNotify companies={state.companies} />;
  if (tab === "pricing") return <PricingSettings />;
  if (tab === "revenue") return <RevenueCard />;
  if (tab === "system") return <SystemPanel section={sub} onSection={onSub} />;

  if (tab === "email")
    return (
      <div className="grid gap-6">
        <EmailStatusCard />
        <EmailMetricsCard />
      </div>
    );

  if (tab === "staff") return <StaffPanel />;
  if (tab === "avatars") return <AvatarResetPanel />;
  if (tab === "audit") return <AuditLog />;
  return <ErrorLogs logs={state.logs} />;
};
